import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Remove from '@material-ui/icons/Remove'
import MoreHoriz from '@material-ui/icons/MoreHoriz'

import PageWrapper from 'templates/PageWrapper'
import TablePreloader from 'components/atoms/TablePreloader'
import GraphLineLabel from 'components/atoms/GraphLineLabel'
import OverviewGraph from 'components/organisms/Overview/Graph'
import OverviewStats from 'components/organisms/Overview/Stats'
import OverviewPlaceholder from 'components/atoms/OverviewPlaceholder'

export const styles = theme => ({
  root: {
    animation: 'fadeIn .3s ease',
    marginTop: theme.spacing(6),
  },
  loader: {
    height: 412,
    display: 'flex',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  graph: {
    marginTop: theme.spacing(4),
  },
})

const Overview = ({ classes, overviewData, hidePlaceholder }) => (
  <PageWrapper className={classes.root}>
    {overviewData ? (
      <React.Fragment>
        {hidePlaceholder && overviewData.organisationOverviewDetails.length ? (
          <React.Fragment>
            <div className={classes.header}>
              <Typography variant="h1">Total kills per month</Typography>
              <div className={classes.header}>
                <GraphLineLabel text="Kills per month" icon={Remove} />
                <GraphLineLabel
                  text="Percentage of trap data synced"
                  icon={MoreHoriz}
                />
              </div>
            </div>
            <div className={classes.graph}>
              <OverviewGraph data={overviewData.organisationOverviewDetails} />
            </div>
            <OverviewStats data={overviewData} />
          </React.Fragment>
        ) : (
          <OverviewPlaceholder />
        )}
      </React.Fragment>
    ) : (
      <div className={classes.loader}>
        <TablePreloader color="#419EF6" />
      </div>
    )}
  </PageWrapper>
)

Overview.propTypes = {
  overviewData: PropTypes.object,
  hidePlaceholder: PropTypes.bool,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Overview)



// WEBPACK FOOTER //
// ./src/containers/organisation/Overview/Overview.js